import { Type } from '@angular/core';

import { ModalComponent } from './Component/modal';
import { ModalHeaderComponent } from './Component/modal-header';
import { ModalBodyComponent } from './Component/modal-body';
import { ModalFooterComponent } from './Component/modal-footer';
import { AutofocusDirective } from './directives/autofocus';


export * from './Component/modal';
export * from './Component/modal-header';
export * from './Component/modal-body';
export * from './Component/modal-footer';
export * from './Component/modal-instance';
export * from './directives/autofocus';


export const MODAL_DIRECTIVES: Array<Type<any>> = [
    ModalComponent,
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    AutofocusDirective
];


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/shared/modeldialog/index.ts